/**
 * 带 取消、确认 按钮的dialog弹窗
 */

import React from 'react';
import {createPortal} from 'react-dom';
import styles from './DialogConfirm.module.scss';

interface Props {
    visible: boolean;
    title: string;
    children: React.ReactNode;
    okBtnText: string;
    cancelBtnText: string;
    onCancel: () => void;
    onOk: () => void;
    // 点击遮罩层
    onMaskClick?: () => void;
}
export function DialogConfirm(props: Props) {
    let dialogClass = styles.dialog;
    if (props.visible) {
        dialogClass += ' ' + styles.dialogVisible;
    }
    const dom = (
        <div className={dialogClass}>
            <div onClick={props.onMaskClick} className={`weui-mask ${styles.mask}`}></div>
            <div className={`weui-dialog ${styles.body}`}>
                <div className="weui-dialog__hd"><strong className="weui-dialog__title">{props.title}</strong></div>
                <div className="weui-dialog__bd">{props.children}</div>
                <div className="weui-dialog__ft">
                    <span onClick={props.onCancel} className="weui-dialog__btn weui-dialog__btn_default">{props.cancelBtnText}</span>
                    <span onClick={props.onOk} className="weui-dialog__btn weui-dialog__btn_primary">{props.okBtnText}</span>
                </div>
            </div>
        </div>
    );
    return createPortal(dom, document.body);
}
